<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="90px"
        :label-position="labelPosition"
      >
        <div class="item-box">
          <div class="item">
            <el-form-item label="设备:" prop="platform">
              <el-select
                v-model="params.platform"
                :disabled="type==='edit'"
                size="small"
                placeholder="请选择设备"
              >
                <el-option label="android" value="android"></el-option>
                <el-option label="ios" value="ios"></el-option>
                <el-option label="h5" value="h5"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="item">
            <el-form-item label="版本号:" prop="verName">
              <el-input
                v-model="params.verName"
                :disabled="type==='edit'"
                size="small"
                placeholder="请输入版本号"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="item-box">
          <div class="item">
            <el-form-item label="包安装ID:" prop="buildId" v-if="params.platform !== 'h5'">
              <el-input v-model="params.buildId" type="text" size="small" placeholder="请输入包安装id"></el-input>
            </el-form-item>
          </div>
          <div class="item">
            <el-form-item label="指定要升级到的版本:">
              <el-input
                v-model="params.specVersion"
                size="small"
                @input="$forceUpdate()"
                placeholder="要升级到的版本号"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="item-box">
          <el-form-item label="更新范围:" prop="versionRange" v-if="params.platform !== 'h5'">
            <el-input v-model="params.versionRange.minor" size="small" placeholder="支持的最小版本号"></el-input>-->
            <el-input v-model="params.versionRange.major" size="small" placeholder="支持的最大版本号"></el-input>
          </el-form-item>
        </div>
        <p
          class="item"
          style="color:green;font-size:12px;margin:-20px 0px 20px 30px"
        >提示：可以升级到当前版本的前版本范围，如果可以升级到当前版本的范围全部为空，则表示全部版本都可升级</p>
        <div class="item-box">
          <el-form-item label="来源:" prop="origin">
            <el-select
              v-model.number="params.origin"
              size="small"
              placeholder="请选择来源"
              show="templete"
            >
              <el-option label="正常" :value="0"></el-option>
              <el-option label="TF版" :value="1"></el-option>
              <el-option label="马甲包" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="下载地址:" prop="url" v-if="params.origin!=1">
          <el-input type="textarea" v-model.trim="params.url" size="small" placeholder="请输入下载地址"></el-input>
        </el-form-item>
        <el-form-item label="下载地址:" prop="tfUrl" v-if="params.origin==1">
          <div class="fb" v-for="(item, i) in params.tfUrl" :key="i">
            <div>
              url:
              <el-input size="small" v-model.trim="item.url"></el-input>
            </div>
            <div style="margin:0 10px">
              名称:
              <el-input size="small" v-model.number="item.name"></el-input>
            </div>
            <div class="fb_right">
              <el-button type="primary" icon="el-icon-delete" size="small" @click="deleteItem(i)"></el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="更新说明:" prop="description">
          <el-input v-model="params.description" type="textarea" size="small" placeholder="请输入更新说明"></el-input>
        </el-form-item>

        <div class="item-box">
          <div class="item">
            <el-form-item label="是否开启:" prop="isActive" v-if="params.platform !== 'h5'">
              <el-switch v-model="params.isActive"></el-switch>
            </el-form-item>
          </div>
          <div class="item">
            <el-form-item
              label="强制更新:"
              prop="forcedUpdate"
              @change="$forceUpdate"
              v-if="params.platform !== 'h5'"
            >
              <el-switch v-model="params.forcedUpdate"></el-switch>
            </el-form-item>
          </div>
        </div>
        <div class="item-box">
          <div class="item">
            <el-form-item label="提审通过:" prop="passCheck" v-if="params.platform !== 'h5'">
              <el-switch v-model="params.passCheck"></el-switch>
            </el-form-item>
          </div>
          <div class="item">
            <el-form-item label="是否升级:" prop="isUpgrade" v-if="params.platform !== 'h5'">
              <el-switch v-model="params.isUpgrade"></el-switch>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="添加url操作:" v-show="params.origin==1">
          <el-button type="primary" size="small" @click="addurl">+新增下载地址</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { validatorVerName } from "@/utils/validator";
export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title: "",
      flag: false,
      type: "",
      id: "",
      // 新增、编辑表单数据
      params: {
        tfUrl: [],
        platform: "",
        verName: "",
        url: "",
        origin: "",
        isActive: false,
        description: "",
        forcedUpdate: false,
        buildId: "",
        passCheck: false,
        isUpgrade: false,
        versionRange: {
          major: "",
          minor: ""
        }
      },
      // 表单验证规则
      rules: {
        platform: [
          { required: true, message: "请选择设备名称", trigger: "change" }
        ],
        verName: [
          { required: true, message: "请输入版本号", trigger: "blur" },
          { validator: validatorVerName, trigger: "blur" }
        ],
        url: [{ required: true, message: "请输入下载地址", trigger: "blur" }],
        description: [
          { required: true, message: "请输入更新说明", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 删除某项
    deleteItem(i) {
      this.params.tfUrl.splice(i, 1);
    },
    // 新增url
    addurl() {
      this.params.tfUrl = this.params.tfUrl ? this.params.tfUrl : [];
      // eslint-disable-next-line no-console
      console.log(this.params.tfUrl);
      // const key = this.params.tfUrl.length
      // if(key >0 && this.params.tfUrl[key-1].url !== '') {
      //      this.params.tfUrl.push(obj);
      // }
      // if(key === 0) {
      this.params.tfUrl.push({ url: "", name: "" });
      // }
    },
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.flag = true;
          if (this.type === "add") {
            this.addVersions();
          } else {
            this.editVersion();
          }
        } else {
          return false;
        }
      });
    },
    // 添加标签
    addVersions() {
      let params = Object.assign({}, this.params, {
        url:
          this.params.origin === 1
            ? JSON.stringify(this.params.tfUrl)
            : this.params.url
      });
      if (params.platform === "h5") {
        params = Object.assign({}, params, {
          isActive: true,
          forcedUpdate: true
        });
      }
      // eslint-disable-next-line no-console
      console.log(params);
      API.getVersionPost(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "添加成功",
              type: "success"
            });
            this.$emit("handlerVersionList");
          } else if (res.code === 9200) {
            this.$message.error("新增版本号低于当前最新版本");
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("添加失败");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 编辑标签
    editVersion() {
      let params = Object.assign({}, this.params, {
        id: this.id,
        url:
          this.params.origin === 1
            ? JSON.stringify(this.params.tfUrl)
            : this.params.url
      });
      delete params.tfUrl;
      if (params.platform === "h5") {
        params = Object.assign(params, {
          isActive: true,
          forcedUpdate: true
        });
      }
      API.getVersionPut(params)
        .then(res => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功",
              type: "success"
            });
            this.$emit("handlerVersionList");
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("编辑失败");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        tfUrl: [],
        platform: "",
        verName: "",
        url: "",
        origin: "",
        isActive: false,
        description: "",
        forcedUpdate: false,
        passCheck: false,
        isUpgrade: false,
        versionRange: {
          major: "",
          minor: ""
        }
      };
    },
    // 判断数据类型是否为JSON
    isJson(str) {
      if (typeof str === "string") {
        try {
          JSON.parse(str);
          return true;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
          return false;
        }
      }
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      if (type === "edit") {
        this.title = "编辑版本";
        this.params.platform = data.platform;
        this.params.verName = data.verName;
        // 判断url是否是tf型
        if (data.origin === 1) {
          // 判断url是否是JSON字符串
          if (this.isJson(data.url)) {
            this.params.tfUrl = JSON.parse(data.url);
          } else {
            this.params.tfUrl = [{ name: "", url: data.url }];
          }
        } else {
          this.params.url = data.url;
        }
        this.params.origin = data.origin;
        this.params.isActive = data.isActive;
        this.params.forcedUpdate = data.forcedUpdate;
        this.params.description = data.description;
        this.params.buildId = data.buildId;
        this.params.passCheck = data.passCheck;
        this.params.versionRange.major = data.versionRange.major;
        this.params.versionRange.minor = data.versionRange.minor;
        this.params.isUpgrade = data.isUpgrade;
        this.params.specVersion = data.specVersion;
        this.id = data.id;
      } else {
        this.title = "新增版本";
      }
    }
  }
};
</script>

<style lang="scss" >
.edit-video-box {
  .item-box {
    width: 100%;
    display: flex;
    .item {
      flex: 1;
    }
  }
  .fb {
    display: flex;
    justify-content: flex-start;
    //  justify-self: start;
  }
}
</style>
